import React from "react";
import { t } from "../../../../../utils/i18n";

const Carousel = () => (
  <div
    id="p2pBannerCarousel"
    className="carousel slide"
    data-ride="carousel"
    data-interval="5000"
  >
    <ol className="carousel-indicators">
      <li
        data-target="#p2pBannerCarousel"
        data-slide-to="0"
        className="active"
      ></li>
      <li data-target="#p2pBannerCarousel" data-slide-to="1"></li>
      <li data-target="#p2pBannerCarousel" data-slide-to="2"></li>
      <li data-target="#p2pBannerCarousel" data-slide-to="3"></li>
    </ol>
    <div className="carousel-inner p2p-banner">
      <div className="carousel-item active">
        <h2 className="carousel-item-h2">
          {t("p2p.offers.banner1_title")}
        </h2>
        <h5 className="carousel-item-h5">
          {t("p2p.offers.banner1_text")}
        </h5>
      </div>

      <a
        href="https://www.bananacrystal.com/bc-debit-card/"
        className="carousel-item"
      >
        <div>
          <h2 className="carousel-item-h2">{t("p2p.offers.banner2_title")}</h2>
          <h5 className="carousel-item-h5">
            {t("p2p.offers.banner2_text")}
          </h5>
        </div>
      </a>

      <a
        href="https://www.bananacrystal.com/business/"
        className="carousel-item"
      >
        <div>
          <h2 className="carousel-item-h2">
            {t("p2p.offers.banner3_title")}
          </h2>
          <h5 className="carousel-item-h5">
            {t("p2p.offers.banner3_text")}
          </h5>
        </div>
      </a>

      <a
        href="https://www.bananacrystal.com/referral-program/"
        className="carousel-item"
      >
        <div>
          <h2 className="carousel-item-h2">{t("p2p.offers.banner4_title")}</h2>
          <h5 className="carousel-item-h5">
            {t("p2p.offers.banner4_text")}
          </h5>
        </div>
      </a>
    </div>
  </div>
);

export default Carousel;
